import ReportsContainer from '@components/containers/Reports/ReportsContainer';
import AppLayout from '@layouts/AppLayout';

export default function Reports() {
    return (
        <AppLayout>
            <ReportsContainer />
        </AppLayout>
    );
}
